var ENV = process.env.VUE_APP_ENV;
var pathUrl = function () {
  var URLS = {
    test: {
      domain: "https://hm.huichenit.com",
      evaluation: "https://hitest.miaocloud.net",
      hMobileHost: "https://htest.miaocloud.net",
      cDomain: "https://hm.huichenit.com",
      jDomain: "https://hm.huichenit.com",
      changcheng_qnId: "3502010002002",
    },
    prod: {
      domain: "https://hm.huichenit.com",
      evaluation: "https://hi.miaocloud.net",
      hMobileHost: "https://hm.huichenit.com",
      cDomain: "https://hm.huichenit.com",
      jDomain: "https://hm.huichenit.com",
      changcheng_qnId: "3456010002002",
    },
    local: {
      // 本地开发走 dev 代理：/api -> localhost:31000（见 vue.config.js）
      domain: "/api",
      feiyang: "/api",
      evaluation: "https://hitest.miaocloud.net",
      hMobileHost: "https://htest.miaocloud.net",
      jDomain: "http://localhost:8080",
      changcheng_qnId: "3502010002002",
    },
  };
  if (process.env.NODE_ENV === "development") {
    return URLS["local"];
  } else {
    return URLS[ENV];
  }
};
let baseUrl = pathUrl().domain || "";
let feiyang = pathUrl().feiyang || "";
let evaluationHost = pathUrl().evaluation || "";
let changcheng_qnId = pathUrl().changcheng_qnId || "";
let hMobileHost = pathUrl().hMobileHost || "";
let cDomain = pathUrl().cDomain || "";
let jDomain = pathUrl().jDomain || "";
export {
  baseUrl,
  evaluationHost,
  changcheng_qnId,
  hMobileHost,
  cDomain,
  jDomain,
  feiyang,
};
